export default __webpack_public_path__ + "static/IBMPlexSans-Regular-83685fed09667ac7947ccb791e07756f.woff2";